import React from "react";
import Axios from 'axios';
import Head from "next/head";
import styled from "styled-components";
import Alert from "@material-ui/lab/Alert";
import Container from "@material-ui/core/Container";
import Backdrop from "@material-ui/core/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import WhitelistForm from "../../components/WhitelistForm";
import { WhitelistApplicationRequest } from "lib/types/whitelist";

const StyledContainer = styled(Container)`
  height: 100%;
  padding-top: 30px;
  padding-bottom: 30px;

  @media(max-width: 600px) {
    padding-bottom: 100px;
  }
`

export default function Whitelist() {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const charge = (data: WhitelistApplicationRequest) => {
    setLoading(true);

    Axios.post('/api/whitelist', data)
      .then(({ data }) => {
        window.location.href = data.redirectUrl;
      })
      .catch((error) => {
        setError(error.response?.data?.message || 'Não foi possível enviar seu formulário.');
        setLoading(false);
      });
  };

  return (
    <>
      <Head>
        <title>Whitelist | RPRP</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {/* <Backdrop open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Snackbar open={!!error} autoHideDuration={6000}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <StyledContainer maxWidth="sm">
        <WhitelistForm onSend={(data) => charge(data)} />
      </StyledContainer> */}
    </>
  )
}
